module.exports = __webpack_public_path__ + "img/3.b2735cb5.png";